import { Colors } from '@brg/ui';
import hexToRGB from 'shared/helpers/hexToRGB';

import type { ApplicationThemeT } from './index';

export const additionalWhite_2: Partial<ApplicationThemeT> = {
    themeName: 'additionalWhite_2',
    accent: {
        colorA: '',
        colorB: '',
        colorC: '',
        colorD: '',
    },
    app: {
        backgroundColor: Colors.gal,
        text: Colors.galBlack100,
        ten: Colors.galBlack10,
    },
    mainBg: '#FEFEFE',
    loading: Colors.galBlack47,
    tabs: {
        gradient: Colors.gal
    },
    peoplePage: {
        title: {
            color: '#212529'
        }
    },
    mainSearchBar: {
        bg: '#f2f2f2',
        placeholder: {
            color: Colors.galBlack47
        },
        input: {
            bg: '#ffffff',
            placeholder: {
                color: '#CDCDCD'
            }
        },
        text: {
            color: Colors.galBlack100,
            color_desc: '#909090',
            hover: {
                color: '#E7E7E7'
            }
        },
        tabs: {
            color: "#909090",
            colorActive: "#151514"
        }
    },
    subscribeInfo: {
        color: '#151514',
        hover: '#545453'
    },
    longreadTranslated: {
        bg: 'rgba(144, 144, 144, 0.8)',
        color: 'rgba(254, 254, 254, 1)'
    },
    relatedTitle:'#151514', 
    mainSearchBarFooter: {
        bg: '#FEFEFE',
        placeholder: {
            color: '#909090'
        },
    },
    educationSearchBar: {
        result: {
            color: '#909090'
        }
    },
    approvalBlockStyles: {
        color: Colors.galBlack47,
        bg: '#2C2C2B',
        radioCircle: '#FEFEFE',
        radioDot: Colors.galBlack100,
        buttonColor: '#FEFEFE',
        buttonBg: '#151514'
    },
    mainDropdownStyles: {
        colorActive: Colors.galBlack100,
        color: Colors.galBlack47,
        bg: 'rgb(242, 242, 242)',
        hoverBG: 'rgb(231, 231, 231);'
    },
    tagView: {
        titleColor: '#1F1F1F',

        // Медиа
        goToMediaColor: '#909090',
        goToMediaHoverColor: '#1F1F1F',
    },
    progressbar: {
        color: Colors.galBlack47,
        colorBold: Colors.galBlack100,
        borderColor: Colors.galBlack31
    },
    folders: {
        emptyModal: {
            titleColor: '#151514',
            subtitleColor: '#151514',
            hoverColor: '#909090'
        },
        editModal: {
            mainbg: '#fefefe',
            titleColor: '#151514',
            subtitleColor: '#909090',
            inputColor: '#f2f2f2',
            inputColor2: '#151514',
            buttonColorHollow: '#151514',
            buttonColorFill: '#fff',
            iconColor: '#151514'
        }
    },
    competition: {

        modal: {
            tagsTitle: {
                color: '#909090'
            }
        },
        search: {
            smallColor: Colors.geoWhite61
        },
        jury: {
            name: '#151514'
        },
        shortList: {
            description: {
                text: '#151514'
            }
        },
        result_table: {
            color: '#545453',
            border: '#E7E7E7'
        },
        bg: '#343434',
        mainText: '#1F1F1F',
        frameMainText: '#151514',
        secondaryText: Colors.galBlack47,
        buttonBg: Colors.galBlack100,
        buttonText: Colors.geoWhite100,
        juryDesc: '#909090',
        input: {
            bg: Colors.galBlack5,
            bgActive: Colors.galBlack10,
            inputText: Colors.galBlack47,
            placeholder: '#838382',
            mainText: '#151514',
            secondText: '#151514',
            button: {
                border: Colors.galBlack73,
                bg:  Colors.geoWhite100
            },
            checkbox: {
                border: Colors.galBlack31,
                icon: '#151514',
                bg:  Colors.geoWhite100,
            }
        },
        label: {
            color: '#909090'
        },
        langComponent: {
            active: {
                bg: '#70706F',
                color: '#fefefe'
            },
            notActive: {
                bg: '#f2f2f2',
                color: '#70706F'
            },
            mainSwitcher: {
                active: {
                    bg: '#151514',
                    color: '#fefefe'
                },
                notActive: {
                    bg: 'transparent',
                    color: '#151514'
                },
            }
        },
        table: {
            item: {
                bg: '#fefefe'
            },
            input: {
                bg: '#f2f2f2',
                color: '#151514',
                border: '#fefefe'
            }
        }
    },
    tagSearch: {
        titleColor: '#151514',
        inputColor: '#151514',
        background: Colors.galBlack5,
        subtitleColor: Colors.galBlack47,
        subtitleColorHover: Colors.galBlack100,
        arrowColor: Colors.galBlack47
    },
    longread: {
        border: '1px solid #E0E0E0',
        fontSize: '20px',
        lineHeight: '32px',
    },
    catalog: {
        titleColor: '#151514',
        descriptionColor: "#151514"
    },
    tagItemView: {
        textColor: '#151514',
        borderColor: '#909090',
        borderColorHover: '#151514',
    },
    filterBar: {
        textColor: '#8e9193',
        textColorHover: '#151514',
    },
    backgroundModal: {
        gradient: 'linear-gradient(180deg, rgba(255, 255, 255, 0.52) 0%, rgba(255, 255, 255, 0.9) 100%);',
    },
    legals: {
        textColor: '#151514',
        background: '#fefefe',
        closeBtn: '#909090',
        linkHover: Colors.galBlack100,
    },
    scroll: {
        bg: '#909090'
    },
    mobileLinks: {
        borderColor: "rgba(231, 231, 231, 1)"
    },
    cookies: {
        bg: "#F2F2F2",
        showMore: {
            color: '#151514'
        },
        icon: {
            fill: "#909090",
            hoverFill: "#151514"
        }
    },
    projectEdit: {  
        book: {
            chaptersButtons: {
                hover: {
                    fill: '#151514'
                },
                color: '#151514'
            }
        },
        radio: {
            dot: {
                color: Colors.galBlack100
            }
        },
        protectBlock: {
            input: {
                bg: '#e7e7e7',
                altBg: '#f2f2f2',
                color: '#151514',
                placeholder: {
                    color: '#909090'
                }
            },
            infoMsg: {
                color: '#909090'
            },

            paid_block: {
                button: {
                    bg: '#151514',
                    color: '#fff'
                }
            }
        },
        inputs: {
            bg: Colors.galBlack5,
            color: Colors.galBlack100,
            placeholder: Colors.galBlack31
        },
        presentation: {
            input: {
                bg: '#fff',
                dropdownHover: '#E7E7E7'
            }
        },
        imgContainerBg: 'rgba(242, 242, 242, 1)',
        svgImgFill: Colors.zelWhite47,
        textTips: Colors.galBlack47,
        locationText: Colors.galBlack73,
        locationBoldText: Colors.galBlack73,
        label: Colors.galBlack5,
        frame: {
            mainTitle: {
                color: '#575B5E'
            },
            description: {
                color: '#575B5E'
            },
            link: {
                color: '#6C7073'
            }
        },
        btns: {
           age: {
            bg: '#fefefe',
            border: '#e7e7e7',
            icon: {
                color: '#151514'
            }
           },
            lang: {
                active: '#151514',
                disabled: '#fefefe',
                activeColor: '#FEFEFE',
                disabledColor: '#151514',
                biling: {
                    color: '#909090',
                    bg: '#fefefe'
                }
            },
            create: {
                bg: '#151514',
                color: Colors.dryYellow,
                weight: 'bold',
                border: '1px solid transparent',
            },
            tag: {
                bgActive: '#F2F2F2',
                border: Colors.galBlack47,
                borderActive: '#B8B8B8',
                color:  Colors.galBlack100,
                colorActive: Colors.galBlack100
            },
            navbar: {
                disabled: {
                    bg: '#f2f2f2',
                    color: '#B6B6B5'
                },
                exit: {
                    border: {
                        notActive: {
                            color: '#B6B6B5'
                        }
                    }
                }
            }
        },
        header: {
            color: 'rgba(21 ,21 , 20, 0.47)'
        },
        mobile: {
            inputs: {
                color: '#151514',
                bg: '#F2F2F2',
                placeholder: '#909090'
            },
            items: {
                color: '#151514',
                bg: 'transparent'
            },
            buttons: {
                color: '#151514',
                bg: 'transparent',
                border: '#151514',
                fill: '#151514',
                hover: {
                    color: '#545453',
                    border: '#545453',
                },
                disabled: {
                    bg: 'transparent',
                    color: '#B6B6B5',
                    border: '#B6B6B5',
                }
            }
        },
        search: {
            inputs: {
                fill: "#909090",
                hoverFill: "#151514"
            }
        },
        publishModal: {
            bg: "#fefefe",
            title: {
                color: "#151514"
            },
            subtitle: {
                color: "#151514"
            },
            buttons: {
                hollow: {
                    color: "",
                    bg: "",
                    border: '#b6b6b5'
                },
                filled: {
                    color: "#fefefe",
                    bg: "#151514",
                    border: "transparent"
                }
            }
        }
    },
    tags: {
        extraBackgroundColor: 'transparent',
        textColor: Colors.galBlack100,
        tagsBgDisabled: '#272b2d ',
        tagsColorDisabled: Colors.geoWhite21,
        tagsBorderDisabled: '#3f4548',
        tagsSearchPlaceholderText: '#70706F',
        emptySearchColor: Colors.galBlack61,
        competitionSortColor: '#151514',

        projectEditTagsPlusBtn: Colors.galBlack100,

        borderColor: Colors.galBlack47,
        borderColorHover: Colors.galBlack27,
        borderColorActive: Colors.galBlack100,

        selectedCategory: Colors.galBlack5,

        cloud: {
            background: Colors.galBlack5,
            selectedTag: '#EA3323',
            selectedTagHSE: '#146DEE',
            selectedTagHSEHover: '#0A56C4',
        },

        removable: {
            textColorHover: Colors.geoWhite47,
            borderColorHover: Colors.geoWhite47,

            // Selected when removable
            selected: {
                line: {
                    color: Colors.galBlack100,
                },
                textColor: Colors.galBlack47,
                borderColor: Colors.uiYellowHover,
            },
        },

        selected: {
            backgroundColor: Colors.dryYellow,
            borderColor: Colors.dryYellow,
            textColor: '#2a3034',
            hover: {
                borderColor: Colors.uiYellowHover,
            },
        },
        disabled: {
            backgroundColor: Colors.galBlack21,
            borderColor: '#3f4548',
            color: Colors.geoWhite21,

            hover: {
                borderColor: '#3f4548',
            },
        },
        educational: {
            backgroundColor: Colors.galBlack100,
            backgroundColorHover: 'rgba(31, 31, 31, 1)',
            color: Colors.geoWhite100,
            unitColor: Colors.geoWhite100,
            projectEdit: {
                backgroundColor: Colors.galBlack100,
                backgroundHover: 'rgba(31, 31, 31, 1)',
                color: '#fefefe',
            }
        },
        modal: {
            search: {
                color: Colors.galBlack47,
                border: Colors.galBlack21,
                borderEmpty: 'transparent',
                bg: Colors.galBlack5
            },
            text: {
                color: Colors.galBlack47,
            },
            header: {
                color: Colors.galBlack100,
                colorLvlOne: Colors.galBlack100
            },
            searchResult: {
                bg: '#f2f2f2'
            },
            active: {
                activeTag: Colors.galBlack100,
                border: Colors.galBlack61
            },
            notActive: {
                // tag: Colors.galBlack73,
                tag: Colors.galBlack100,
                border: Colors.galBlack31
            },
            simpleTag: {
                // color: Colors.galBlack100,
                color: Colors.geoWhite100,
                bottomLine: '#E9EAEB'
            }
        }
    },
    hoverModal: {
        bg: {
            color: '#f2f2f2'
        }
    },
    exploreView: {
        titleColor: Colors.galBlack100,
        mapGridToggle: {
            color: '#8e9193',
            colorHover: '#151514',
        },
        illustrationColor: '#212529'
    },
    allTagsBtn: {
        color: '#8E9193',
        colorHover: '#151514',
        colorBooksBtn: "#909090",
        colorHoverBooksBtn: "#545453"
    },
    multipleAuthors: {
        color: '#8e9193',
        colorHover: '#151514',
        bg: Colors.galBlack5,
        bgHover: Colors.galBlack10,
        arrow: '#151514',
        border: '1px solid #151514',
        shadow: '0px 4px 4px rgba(0, 0, 0, 0.12)'
    },
    designerRole: Colors.galBlack61,
    designerRoleUniversity: Colors.galBlack100,
    textBoldMagic: '#8e9193',
    teamLink: '#8e9193',
    teamLinkHover: Colors.galBlack73,
    teamLinkHoverAccent: Colors.geoWhite61,
    projectToolsDropdown: {
        border: '1px solid #151514',
        borderColor: '#151514',
    },
    projectTools: {
        printButton: Colors.galBlack100,
        outer: Colors.galBlack5,
        rowTitle: Colors.galBlack61,
        rowHover: "#EEE",
        okBtn: "#1F1F1F",
        okBtnText: "#FFF",
    },
    checkbox: {
        border: Colors.galBlack47,
        bg: Colors.gal,
        icon: Colors.galBlack100,
    },
    paginationBtn: {
        color: '#151514',
        border: '1px solid #151514',
    },
    sortByColor: '#8e9193',
    sortByColorSort: '#151514',
    sortByBorder: 'none',
    sortByBg: '',
    sortBySpan: '#151514',
    nameViewHover: '#151514',
    nameView: '#8e9193',
    reportForm: {
        backgroundColor: '#fefefe',
        text: '#151514',
        scroll: '#909090',
        btns: {
            submit: {
                bg: '#151514',
                disabledBg: '#B6B6B5',
                disabledColor: '#FEFEFE',
                color: '#FEFEFE',
                border: '',
                hoverBg: '#efd649',
                weight: '',
            },
            cancel: {
                bg: '',
                color: '#151514',
                border: '1px solid #151514',
                hoverBorder: '1px solid #b1b1b1',
            }
        },
        inputs: {
            dropdown: {
                backgroundColor: Colors.galBlack5,
                backgroundColorHover: Colors.galBlack10,
                scroll: Colors.galBlack47,
            },
            optionsBox: {
                shadowColor: 'linear-gradient(180deg, rgba(50, 55, 59, 0.09) 0%, #32373b 100%)',
                borderColor: Colors.galBlack100,
            },
            backgroundColor: Colors.galBlack5,
            borderColor: Colors.galBlack5,
            color: '#151514',
        }
    },
    feedbackForm: {
        backgroundColor: '#fefefe',
        text: '#151514',
        btns: {
            submit: {
                bg: '#151514',
                color: '#F1DB63',
                border: '1px solid #151514',
                hoverBg: '#424242',
                weight: '700',
            },
            cancel: {
                bg: '',
                color: '#151514',
                border: '1px solid #151514',
                hoverBorder: '1px solid #b1b1b1',
            }
        },
        inputs: {
            dropdown: {
                backgroundColorHover: '',
            },
            optionsBox: {
                shadowColor: 'linear-gradient(180deg, rgba(50, 55, 59, 0.09) 0%, #32373b 100%)',
                borderColor: Colors.galBlack100,
            },
            backgroundColor: '#fefefe',
            borderColor: Colors.galBlack31,
            color: '#151514',
        }
    },
    defaultHolder: {
        bg: '#f2f2f2',
        color: '#70706F'
    },
    projectView: {
        titleColor: '#FEFEFE',
        titleColorMobile: Colors.geoWhite100,
        lGTitleColorMobile: Colors.geoWhite100,
        placeholderColor: '#B6B6B5',
        fontSize: '60px',
        lineHeight: '64px',
        tooltipColor: Colors.galBlack61,
        tooltipColorBG: Colors.galBlack10,
        categoryText: Colors.galBlack47,
        categoryWeight: '700',
        categoryColorHover: '#151514',
        authorText: 'rgba(0,0,0,0.47)',
        authorCuratorText: Colors.galBlack100,
        authorTextMobile: Colors.geoWhite100,
        authorWeight: '400',
        authorColor: Colors.galBlack47,
        authorColorHover: Colors.galBlack100,
        authorArrowIconColor: Colors.galBlack47,
        authorColorHoverMobile: Colors.geoWhite61,
        authorTextSize: '30px',
        textAreaColor: '#151514',
        viewCardText: Colors.galBlack73,
        viewCardStroke: '#909090',
        marginTop: '0px',
        marginBottom: '31px',
        moreProjects: '#151514',
        offsetTop: '0',
        madeBy: Colors.galBlack47,
        border: Colors.defaultGrey5,
        competitionMsg: Colors.galBlack100,
        
    },
    icon: {
        // default: Colors.galBlack47,
        default: 'rgba(0,0,0,0.47)',
        hover: Colors.galBlack100,
        active: Colors.galBlack100,
        hoverSpecial: Colors.galBlack100,
        hoverSpecialActive: Colors.galBlack73,
        activeSpecial: Colors.galBlack100,
        activeFillIconColor: Colors.galBlack100,
        rejectedColor: '#F2F2F2',
    },
    skeleton: {
        skeletonBgColor: '#F2F2F2',
        background: `linear-gradient(
            90deg,
            rgba(0, 0, 0, 0.05),
            rgba(0, 0, 0, 0.05),
            rgba(0, 0, 0, 0.05),
            rgba(0, 0, 0, 0.10),
            rgba(0, 0, 0, 0.05),
            rgba(0, 0, 0, 0.05),
            rgba(0, 0, 0, 0.05)
        )`,
    },

    footerView: {
        backgroundColor: '#F2F2F2',
        textColor: '#6C7073',
        textHoverColor: Colors.dryYellow,
        link: Colors.galBlack47,
        linkHover: Colors.galBlack100,
        linkArrow: Colors.galBlack21,
    },
    arrowWithText: {
        hover: {
            text: {
                color: Colors.galBlack100
            },
            svg: {
                fill: Colors.galBlack100,
                stroke: Colors.galBlack100
            }
        }
    },
    teamsPage: {
        button: {
            bg: '#151514'
        },
        dropdown: {
            text: {
                color: '#212529'
            }
        },
        input: {
            bg: "#F2F2F2",
            color: '#212529'
        },
        text: {
            point: {
                color: '#212529'
            },
            label: {
                color: '#212529'
            },
            icon: {
                fill: '#212529'
            },
            color: '#212529'
        },
    },
    fixedFooter: {
        background: {
            color: "#F2F2F2"
        },
        logo: {
            color: "#151514",
        },
        menuItems: {
            color: '#909090',
            colorDropdown: 'rgba(112, 112, 111, 1)',
            colorHover: "#151514",
            selected: Colors.galBlack100,
        },
        doc: {
            color: '#909090',
            colorHover: "#151514",
        },
        icons: {
            circle: '#F2F2F2',
            arrow: '#909090'
        },
        dropdown: {
            color: '#909090',
            fill: '#909090'
        }
    },

    // Выбор контекста - @Яков
    selectContextModal: {
        background: Colors.gal,
        loaderText: '#70706F',
        opacityTop:
            'linear-gradient(to top, rgba(254, 254, 254, 0), rgba(254, 254, 254, 0.6) 12.39%, rgba(254, 254, 254, 1))',
        opacityBottom:
            'linear-gradient(to bottom, rgba(254, 254, 254, 0), rgba(254, 254, 254, 0.6) 12.39%, rgba(254, 254, 254, 1))',
        variantTextColor: Colors.galBlack100,
    },
    ageModal: {
        bg: '#fff',
        input:{
            color: '#151514'
        },
    },
    sendProjectsModal: {
        title: Colors.galBlack100,
        label: Colors.galBlack47,
        countText: '#909090',
        buttons: {
            send: {
                bg: Colors.galBlack100,
                color: Colors.geoWhite100,
                colorGreen: Colors.galBlack100,
                importantColor: Colors.geoWhite100,
                hoverBg: 'rgb(31, 31, 31)',
                greenBg: 'rgb(164, 181, 77)',
                greenBgHover: 'rgb(164, 181, 77)',
                disable: "#E7E7E7",
                disableClr: '#B6B6B5'
            }
        },
        input: {
            color: '#151514',
            bg: '#f2f2f2'
        }
    },
    competitionLegalsModal: {
        input: {
            bg: Colors.geoWhite100,
            placeholder: '#909090',
            color: Colors.galBlack100,
            border: Colors.galBlack100,
            icon: Colors.galBlack100,
            defaultBorder: Colors.galBlack100
        }
    },
    teamConstructor: {
        bg: Colors.geoWhite100,
        description: {
            bg: Colors.galBlack100,
            color: Colors.geoWhite100,
        },
        smallText: {
            color: Colors.galBlack100,
        },
        fields: {
            bg: Colors.galBlack5,
        }
    },
    shopIcon: '#151514',
    shareIcon: '#151514',
    navigationBar: {
        borderBottomColor: ' #C5C6C7',
        textActiveColor: '#151514',
        closeButtonColor: '#000000',
        backgroundColor: Colors.gal,
        mainNavbarColor: 'rgb(42,48,52)',
        backgroundScrollingColor: 'rgba(254, 254, 254, 0.71)',
        backgroundDirtyColor: '#FF0000',
        font: {
            l: {
                fontSize: '17px',
                lineHeight: '22px'
            },
            m: {
                fontSize: '15px',
                lineHeight: '20px'
            },
            s: {
                fontSize: '13px',
                lineHeight: '16px'
            }
        },
        links: {
            color: Colors.geoWhite47,
            hoverColor: Colors.galBlack100,
            activeColor: Colors.galBlack100,
            disabledColor: 'rgba(142, 145, 147, 0.3)',
            disabledHoverColor: 'rgba(21, 21, 20, 0.3)'
        },
        linksHse: {
            color: Colors.galBlack47,
            hoverColor: Colors.galBlack100,
            activeColor: Colors.galBlack100,
            disabledColor: 'rgba(142, 145, 147, 0.3)',
            disabledHoverColor: 'rgba(21, 21, 20, 0.3)'
        },
        logoName: Colors.galBlack100,
        logoPrefixName: '#FF0000',
        login: {
            loginButtonColor: Colors.geoWhite47,
            loginButtonHoverColor: '#151514',
            noAvatarBackgroundColor: '#30363A',
            noAvatarTextColor: '#707477',
        },
        search: {
            color: '#151514',
            line: '#151514',
            svg: Colors.geoWhite47,
            svgHover: Colors.galBlack100,
            colorFlex: '#151514',
        },
        btns: {
            purchase: {
                background: {
                    color: Colors.galBlack100
                },
                text: {
                    color: Colors.geoWhite100
                }
            },
            filled: {
                importantStyles: {
                    main: Colors.geoWhite100,
                    disabled: Colors.galBlack10,
                    hover: Colors.geoWhite100,
                    active: Colors.galBlack10,
                    text: Colors.galBlack100
                },
                background: {
                    main: Colors.galBlack100,
                    disabled: Colors.galBlack10,
                    active: 'rgba(21, 21, 20, 1)',
                    hover: 'rgba(31, 31, 31, 1)',
                },
                text: {
                    main: '#FFFFFF',
                    disabled: Colors.galBlack31,
                },
            },
            hollow: {
                background: {
                    disabled: Colors.galBlack10,
                },
                text: {
                    main: Colors.galBlack100,
                    grey: Colors.geoWhite31,
                    black: Colors.galBlack100,
                    disabled: Colors.galBlack31,
                },
                border: {
                    main: Colors.galBlack31,
                    hover: Colors.galBlack47,
                    active: Colors.galBlack100,
                    disabled: Colors.galBlack31,
                },
            },
            send: {
                color: 'transparent',
                textColor: '#151514',
                border: '',
            },
            create: {
                bg: '#151514',
                color: '#FFFFFF',
                weight: 'bold',
                border: '1px solid transparent',
            },
            changeLang: {
                background: Colors.geoWhite100,
                color: Colors.galBlack47,
                colorMobile: Colors.galBlack100,
                colorHover: Colors.galBlack47,
                active: Colors.galBlack100,
            },
            showMore: {
                hover: {
                    color: '#151514'
                }
            }
        },
        modalMobileLinks: {
            default: Colors.galBlack47,
            active: Colors.galBlack100,
        },
        linksWidgetLine: '#151514',
        linksWidgetLineGradient: Colors.galBlack100, //old 'radial-gradient(100% 1562500% at 0% 100.02%,rgba(255, 255, 255, 0) 0%,#151514 49.87%,rgba(254, 254, 254, 0) 100%)',
        navBarCreate: {
            boldTextColor: Colors.galBlack73,
            textColor: Colors.galBlack73,
            logoFillColor: {
                first: '#151514',
                second: '#151514',
            },
        },
        dropdownStyled: {
            borderFocused: '#151514',
            bg: '#fefefe',
            border: '1px solid #B6B6B5',
            textColor: '#151514',
            opacity: '0.7',
            fill: '#151514',
        },
        profile: {
            textColor: '#151514',
            textSmallColor: '#8e9193',
            bg: '#fefefe',
        },
        mobileMenu: {
            item: {
                color: '#151514',
                bg: '#F2F2F2'
            },
            container: {
                bg: '#F2F2F2'
            },
            search: {
                bg: '#fefefe'
                // bg: '#f2f2f2'
            },
            tab: {
                color: '#909090',
                colorActive: '#151514'
            }
        }
    },
    mobileSearch: {
        wrapper: {
            background: Colors.galBlack5,
            backgroundHover: Colors.galBlack10,
        },
        scroll: {
            body: '#909090',
            background: Colors.galBlack10,
        },
        input: {
            color: Colors.galBlack100
        },
        item: {
            color: Colors.galBlack100,
        }
    },
    likesController: {
        textColor: Colors.galBlack47,
        fill: '',
        hearthColor: Colors.galBlack47,
        hearthColorLikes: Colors.redFailed,
        text: Colors.galBlack47,
    },
    viewCount: {
        text: Colors.galBlack47
    },
    likesPopUp: {
        bg: '#fefefe',
        color: '#8e9391',
        hoverColor: '#151514',
        bgHover: '#f2f2f2',
        borderBox: '1px solid black',
    },
    likesPopUpNew: {
        bg: Colors.galBlack5,
        color: Colors.galBlack100,
        bgHover: Colors.galBlack10,
        scrollBody: Colors.galBlack47,
    },
    researchPage: {
        colorMainTitle: '#151514',
    },
    btns: {
        submit: {
            bg: '#151514',
            color: '#F1DB63',
            border: '1px solid #151514',
            hoverBg: '#424242',
            weight: '700',
        },
        cancel: {
            bg: '',
            color: '#151514',
            border: '1px solid #151514',
            hoverBorder: '1px solid #b1b1b1',
        },
        hollow: {
            border: Colors.galBlack31,
            borderActive: Colors.galBlack100,
            icon: Colors.galBlack100,
        },
    },
    inputs: {
        dropdown: {
            backgroundColorHover: '',
        },
        optionsBox: {
            shadowColor: 'linear-gradient(180deg, rgba(50, 55, 59, 0.09) 0%, #32373b 100%)',
            borderColor: Colors.galBlack100,
        },
        backgroundColor: Colors.geoWhite100,
        borderColor: Colors.galBlack31,
        borderFocusedColor: Colors.galBlack100,
        color: '#151514',
        disabledColor: Colors.galBlack47,
        pagination: {
            backgroundColor: Colors.galBlack10,
            color: Colors.galBlack100,
            mainPagination: {
                pageBg: {
                    bg: '#E7E7E7'
                }
            }
        },
        box: {
            backgroundColor: Colors.galBlack5
        },
        label: {
            color: Colors.galBlack73
        },
        text: {
            color: Colors.galBlack47
        }
    },
    dropdown: {
        textColor: '#151514',
        bgColor: '#fefefe',
        bgColorHover: '#f2f2f2',
        borderColor: '#B6B6B5',
        borderFocusColor: '#151514',
        arrow: '#151514',
        shadow: 'rgba(0,0,0,0)',
        shadowEnd: 'rgba(254,254,254,1)',

        shadowHse: 'rgba(0,0,0,0)',
        shadowHseEnd: '#343434',
        webkitShadowStart: 'rgba(52,52,52,1)',
        webkitShadowEnd: 'rgba(52,52,52,0.3)'
    },
    spinner: {
        loaderColor: '#F2F2F2',
        loaderBg: '#fefefe',
    },
    designerPage: {
        emptyProjectsLoader: {
            color: '#151514',
            bg: '#F2F2F2',
        },
        noProjectBlock: {
            infoBlock: {
                bg: '#f2f2f2',
                color: '#151514'
            },
            avatar: {
                color: '#70706f',
                bg: '#CDCDCD',
                size: {
                    l: 48,
                }
            }
        },
        likePowerIcon: {
            color: Colors.galBlack47,
            bg: 'rgba(21,21,20,0.73)',
            opacity: '0.73',
            msgColor: Colors.geoWhite100,
            shrinkColor: Colors.geoWhite100,
            hover: Colors.galBlack73
        },
        slideShadow: 'linear-gradient(270deg, #FFF 9.68%, rgba(255, 255, 255, 0.00) 100%)',
        slideItemBg: Colors.defaultGrey6,
        textColor: '#151514',
        textColor2: Colors.galBlack47,
        textColor3: Colors.galBlack100,
        sliderDropdownColor: Colors.galBlack100,
        fill: '#151514',
        moreDropdown: '1px solid #151514',
        slideLine: '#151514',
        slideNavActiveTabUnderline: '#151514',
        slideLineInActive: Colors.galBlack47,
        slideHover: Colors.galBlack73,
        blueSelectBG: '#609AF0',
        blueSelectColor: '#fefefe'    
    },
    wideCover: {
        info: {
            author: {
                color: Colors.galBlack47,
            },
            title: {
                color: '#151514'
            }

        }
    },
    teamsEdit: {
        inputs: {
            labelColor: Colors.galBlack47,
            importantColor: Colors.galBlack47,
            whiteLabelColor: Colors.galBlack47,
            bgDisabled: '#f2f2f2',
            bg: '#ffffff',
            border: '1px soled #8E9193',
            color: '#151514',
            colorShadow: '#BFBFBF'
        }
    },
    designerEdit: {
        btns: {
            edit: {
                bg: '#151514',
                color: Colors.geoWhite100,
                border: '1px solid #151514',
                hoverBg: '#424242',
                weight: '700',
            },
            cancel: {
                bg: '',
                color: '#151514',
                border: '1px solid #151514',
                hoverBorder: '1px solid #b1b1b1',
            },
            roundAdd: {
                svgColor: 'black',
                textColor: Colors.galBlack47,
            },
        },
        localSwitch: {
            borderColor: '#151514',
            textColor: '#151514',
            textColorInactive: Colors.galBlack47,
            textColorHover: '#151514',
        },
        inputs: {
            labelColor: Colors.galBlack47,
            importantColor: Colors.galBlack47,
            whiteLabelColor: Colors.galBlack47,
            bgDisabled: '#f2f2f2',
            bg: '#ffffff',
            border: '1px soled #8E9193',
            color: '#151514',
            colorShadow: '#BFBFBF'
        },
        smallText: {
            color73: '#8E9193',
            color100: '#8E9193',
            color47: Colors.galBlack47,
            colorB6: '#B6B6B5',
            colorE7: '#8E9193'
        },
        editTitle: {
            color: Colors.galBlack61,
            secondColor: Colors.galBlack100
        },
        mainTitle: {
            color: Colors.galBlack100,
        },
        pageLink: {
            color: Colors.galBlack47,
            hoverColor: '#151514',
        },
        aboutProfile: {
            bg: Colors.galBlack5,
            bgWhite: '',
            color: '#545453',
        },
        mergeAccount: {
            bg: Colors.geoWhite100
        },
        account: {
            color: Colors.galBlack73,
            color47: Colors.galBlack47,
            goButtonColor: Colors.galBlack73,
            color31: Colors.geoWhite10,
            fill: Colors.galBlack21
        },
        icons: {
            color: Colors.galBlack47,
            colorHover: Colors.galBlack100
        },
        disable: {
            color: Colors.galBlack27,
            colorGeo: ''
        },
        placeholder: {
            color: Colors.galBlack47,
        }
    },
    map: {
        closeBtn: '#151514',
        bg: '#fefefe',
        teams: {
            text: Colors.galBlack61,
            secondaryText: Colors.galBlack47,
            scroll: '#CDCDCD'
        }
    },
    footer: {
        border: 'transparent',
    },
    errorModal: {
        textColor: Colors.galBlack100,
        textColorSecond: Colors.galBlack73,
        secondaryTextColor: Colors.galBlack47,
        backgroundColor: Colors.gal,
    },

    modal: {
        closeColor: Colors.galBlack100,
        backgroundColor: 'rgba(255, 255, 255)',
        solidBackgroundColor: Colors.gal,
        overflowColor: 'rgba(21, 21, 20, 0.6)',
    },
    not_saved_modal: {
        title: Colors.galBlack100,
        description: Colors.galBlack61,
        cancel: Colors.geoWhite100,
        proceed: Colors.galBlack100,
        channelTitle: Colors.galBlack100
    },
    menuOverlay: {
        buttonBackground: '#fefefe',
        buttonContent: 'rgb(142, 145, 147)',
        buttonOpacity: 1,
        backgroundColor: '#FEFEFE',
        textColor: '#151514',
        textColorAlternative: '#abaeaf',
        borderTitle: '#151514',
        flexBox: 'rgb(254, 254, 254, 0.71)',
    },
    approvals: {

    },
    isDarkText: true,
    link: {
        default: Colors.galBlack47,
        hover: Colors.galBlack100,
    },
    linkSpecial: {
        hover: Colors.galBlack100,
    },
    scrollUp: {
        link: '#909090',
        background: 'transparent',
        backgroundHover: hexToRGB('#909090', 0.01)
    },
    text: {
        label: Colors.galBlack47,
    },
    mobileMenu: {
        background: '#FFFFFF',
    },
    notifications: {
        background: Colors.galBlack5,
        backgroundUnread: Colors.galBlack21,
        backgroundHover: "#E7E7E7",
        projectBackground: "#FFFFFF",
        projectBackgroundUnread: Colors.galBlack10,
        likes: Colors.galBlack47,
        textColor: Colors.galBlack100,
        link: Colors.galBlack100,

        name: {
            color: "#151514",
        }
    },
    errorPage: {
        notFound: {
            number: Colors.galBlack21,
            title: Colors.galBlack47
        },
        title: Colors.galBlack73,
        subtitle: Colors.galBlack73,
        text: Colors.galBlack47,
        buttons: {
            border: Colors.galBlack31,
            hollowText: Colors.zel,
            bg: Colors.galBlack100,
            filledText: "#fff",
            disabledBg: Colors.galBlack21,
            disabledColor: Colors.galBlack31,
        }
    },
    imagePlaceholder: {
        bg: Colors.galBlack5,
        icon: Colors.galBlack47
    },
    draftCreate: {
        primary: "#F2F2F2",
        secondary: "#30363a",
        borderHover: "#8e9193",
        textHover: "#8e9193",
        title: Colors.geoWhite61,
        draftCards: {
            psn_card: {
                color: Colors.galBlack100
            }
        }
    },
    tagAdminPage: {
        dropdownSelected: "#151514",
        dropdown: "",
        inputs: {
            bg: '#f2f2f2',
            border: 'rgba(144, 144, 144, 1)',
            placeholder: {
                color: 'rgba(144, 144, 144, 1)'
            }
        },
        checkbox: {
            bg: '#fefefe'
        },
        select: {
            color: '#151514'
        },
        scrollBar: {
            bg: '#909090',
            trackBg: 'rgb(231, 231, 231)'
        },
        icons: {
            fill: '#909090'
        },
        tagExpert: {
            mainText: Colors.galBlack73,
            secondaryText: Colors.galBlack47,
            secondaryTextHover: Colors.galBlack100,
            background: Colors.galBlack5
        },
        switcher: {
            bg: '#F2F2F2',
            item: {
                color: Colors.galBlack47,
                hoverColor: Colors.galBlack100
            }
        }
    },
    madeByMedia: {
        background: '#151514',
        color: '#FEFEFE'
    }
} as ApplicationThemeT;
import { Colors } from '@brg/ui';
import hexToRGB from 'shared/helpers/hexToRGB';

import type { ApplicationThemeT } from './index';

export const additionalWhite_2: Partial<ApplicationThemeT> = {
    themeName: 'additionalWhite_2',
    accent: {
        colorA: '',
        colorB: '',
        colorC: '',
        colorD: '',
    },
    app: {
        backgroundColor: Colors.gal,
        text: Colors.galBlack100,
        ten: Colors.galBlack10,
    },
    mainBg: '#FEFEFE',
    loading: Colors.galBlack47,
    tabs: {
        gradient: Colors.gal
    },
    peoplePage: {
        title: {
            color: '#212529'
        }
    },
    mainSearchBar: {
        bg: '#f2f2f2',
        placeholder: {
            color: Colors.galBlack47
        },
        input: {
            bg: '#ffffff',
            placeholder: {
                color: '#CDCDCD'
            }
        },
        text: {
            color: Colors.galBlack100,
            color_desc: '#909090',
            hover: {
                color: '#E7E7E7'
            }
        },
        tabs: {
            color: "#909090",
            colorActive: "#151514"
        }
    },
    subscribeInfo: {
        color: '#151514',
        hover: '#545453'
    },
    longreadTranslated: {
        bg: 'rgba(144, 144, 144, 0.8)',
        color: 'rgba(254, 254, 254, 1)'
    },
    relatedTitle:'#151514', 
    mainSearchBarFooter: {
        bg: '#FEFEFE',
        placeholder: {
            color: '#909090'
        },
    },
    educationSearchBar: {
        result: {
            color: '#909090'
        }
    },
    approvalBlockStyles: {
        color: Colors.galBlack47,
        bg: '#2C2C2B',
        radioCircle: '#FEFEFE',
        radioDot: Colors.galBlack100,
        buttonColor: '#FEFEFE',
        buttonBg: '#151514'
    },
    mainDropdownStyles: {
        colorActive: Colors.galBlack100,
        color: Colors.galBlack47,
        bg: 'rgb(242, 242, 242)',
        hoverBG: 'rgb(231, 231, 231);'
    },
    tagView: {
        titleColor: '#1F1F1F',

        // Медиа
        goToMediaColor: '#909090',
        goToMediaHoverColor: '#1F1F1F',
    },
    progressbar: {
        color: Colors.galBlack47,
        colorBold: Colors.galBlack100,
        borderColor: Colors.galBlack31
    },
    folders: {
        emptyModal: {
            titleColor: '#151514',
            subtitleColor: '#151514',
            hoverColor: '#909090'
        },
        editModal: {
            mainbg: '#fefefe',
            titleColor: '#151514',
            subtitleColor: '#909090',
            inputColor: '#f2f2f2',
            inputColor2: '#151514',
            buttonColorHollow: '#151514',
            buttonColorFill: '#fff',
            iconColor: '#151514'
        }
    },
    competition: {

        modal: {
            tagsTitle: {
                color: '#909090'
            }
        },
        search: {
            smallColor: Colors.geoWhite61
        },
        jury: {
            name: '#151514'
        },
        shortList: {
            description: {
                text: '#151514'
            }
        },
        result_table: {
            color: '#545453',
            border: '#E7E7E7'
        },
        bg: '#343434',
        mainText: '#1F1F1F',
        frameMainText: '#151514',
        secondaryText: Colors.galBlack47,
        buttonBg: Colors.galBlack100,
        buttonText: Colors.geoWhite100,
        juryDesc: '#909090',
        input: {
            bg: Colors.galBlack5,
            bgActive: Colors.galBlack10,
            inputText: Colors.galBlack47,
            placeholder: '#838382',
            mainText: '#151514',
            secondText: '#151514',
            button: {
                border: Colors.galBlack73,
                bg:  Colors.geoWhite100
            },
            checkbox: {
                border: Colors.galBlack31,
                icon: '#151514',
                bg:  Colors.geoWhite100,
            }
        },
        label: {
            color: '#909090'
        },
        langComponent: {
            active: {
                bg: '#70706F',
                color: '#fefefe'
            },
            notActive: {
                bg: '#f2f2f2',
                color: '#70706F'
            },
            mainSwitcher: {
                active: {
                    bg: '#151514',
                    color: '#fefefe'
                },
                notActive: {
                    bg: 'transparent',
                    color: '#151514'
                },
            }
        },
        table: {
            item: {
                bg: '#fefefe'
            },
            input: {
                bg: '#f2f2f2',
                color: '#151514',
                border: '#fefefe'
            }
        }
    },
    tagSearch: {
        titleColor: '#151514',
        inputColor: '#151514',
        background: Colors.galBlack5,
        subtitleColor: Colors.galBlack47,
        subtitleColorHover: Colors.galBlack100,
        arrowColor: Colors.galBlack47
    },
    longread: {
        border: '1px solid #E0E0E0',
        fontSize: '20px',
        lineHeight: '32px',
    },
    catalog: {
        titleColor: '#151514',
        descriptionColor: "#151514"
    },
    tagItemView: {
        textColor: '#151514',
        borderColor: '#909090',
        borderColorHover: '#151514',
    },
    filterBar: {
        textColor: '#8e9193',
        textColorHover: '#151514',
    },
    backgroundModal: {
        gradient: 'linear-gradient(180deg, rgba(255, 255, 255, 0.52) 0%, rgba(255, 255, 255, 0.9) 100%);',
    },
    legals: {
        textColor: '#151514',
        background: '#fefefe',
        closeBtn: '#909090',
        linkHover: Colors.galBlack100,
    },
    scroll: {
        bg: '#909090'
    },
    mobileLinks: {
        borderColor: "rgba(231, 231, 231, 1)"
    },
    cookies: {
        bg: "#F2F2F2",
        showMore: {
            color: '#151514'
        },
        icon: {
            fill: "#909090",
            hoverFill: "#151514"
        }
    },
    projectEdit: {  
        book: {
            chaptersButtons: {
                hover: {
                    fill: '#151514'
                },
                color: '#151514'
            }
        },
        radio: {
            dot: {
                color: Colors.galBlack100
            }
        },
        protectBlock: {
            input: {
                bg: '#e7e7e7',
                altBg: '#f2f2f2',
                color: '#151514',
                placeholder: {
                    color: '#909090'
                }
            },
            infoMsg: {
                color: '#909090'
            },

            paid_block: {
                button: {
                    bg: '#151514',
                    color: '#fff'
                }
            }
        },
        inputs: {
            bg: Colors.galBlack5,
            color: Colors.galBlack100,
            placeholder: Colors.galBlack31
        },
        presentation: {
            input: {
                bg: '#fff',
                dropdownHover: '#E7E7E7'
            }
        },
        imgContainerBg: 'rgba(242, 242, 242, 1)',
        svgImgFill: Colors.zelWhite47,
        textTips: Colors.galBlack47,
        locationText: Colors.galBlack73,
        locationBoldText: Colors.galBlack73,
        label: Colors.galBlack5,
        frame: {
            mainTitle: {
                color: '#575B5E'
            },
            description: {
                color: '#575B5E'
            },
            link: {
                color: '#6C7073'
            }
        },
        btns: {
           age: {
            bg: '#fefefe',
            border: '#e7e7e7',
            icon: {
                color: '#151514'
            }
           },
            lang: {
                active: '#151514',
                disabled: '#fefefe',
                activeColor: '#FEFEFE',
                disabledColor: '#151514',
                biling: {
                    color: '#909090',
                    bg: '#fefefe'
                }
            },
            create: {
                bg: '#151514',
                color: Colors.dryYellow,
                weight: 'bold',
                border: '1px solid transparent',
            },
            tag: {
                bgActive: '#F2F2F2',
                border: Colors.galBlack47,
                borderActive: '#B8B8B8',
                color:  Colors.galBlack100,
                colorActive: Colors.galBlack100
            },
            navbar: {
                disabled: {
                    bg: '#f2f2f2',
                    color: '#B6B6B5'
                },
                exit: {
                    border: {
                        notActive: {
                            color: '#B6B6B5'
                        }
                    }
                }
            }
        },
        header: {
            color: 'rgba(21 ,21 , 20, 0.47)'
        },
        mobile: {
            inputs: {
                color: '#151514',
                bg: '#F2F2F2',
                placeholder: '#909090'
            },
            items: {
                color: '#151514',
                bg: 'transparent'
            },
            buttons: {
                color: '#151514',
                bg: 'transparent',
                border: '#151514',
                fill: '#151514',
                hover: {
                    color: '#545453',
                    border: '#545453',
                },
                disabled: {
                    bg: 'transparent',
                    color: '#B6B6B5',
                    border: '#B6B6B5',
                }
            }
        },
        search: {
            inputs: {
                fill: "#909090",
                hoverFill: "#151514"
            }
        },
        publishModal: {
            bg: "#fefefe",
            title: {
                color: "#151514"
            },
            subtitle: {
                color: "#151514"
            },
            buttons: {
                hollow: {
                    color: "",
                    bg: "",
                    border: '#b6b6b5'
                },
                filled: {
                    color: "#fefefe",
                    bg: "#151514",
                    border: "transparent"
                }
            }
        }
    },
    tags: {
        extraBackgroundColor: 'transparent',
        textColor: Colors.galBlack100,
        tagsBgDisabled: '#272b2d ',
        tagsColorDisabled: Colors.geoWhite21,
        tagsBorderDisabled: '#3f4548',
        tagsSearchPlaceholderText: '#70706F',
        emptySearchColor: Colors.galBlack61,
        competitionSortColor: '#151514',

        projectEditTagsPlusBtn: Colors.galBlack100,

        borderColor: Colors.galBlack47,
        borderColorHover: Colors.galBlack27,
        borderColorActive: Colors.galBlack100,

        selectedCategory: Colors.galBlack5,

        cloud: {
            background: Colors.galBlack5,
            selectedTag: '#EA3323',
            selectedTagHSE: '#146DEE',
            selectedTagHSEHover: '#0A56C4',
        },

        removable: {
            textColorHover: Colors.geoWhite47,
            borderColorHover: Colors.geoWhite47,

            // Selected when removable
            selected: {
                line: {
                    color: Colors.galBlack100,
                },
                textColor: Colors.galBlack47,
                borderColor: Colors.uiYellowHover,
            },
        },

        selected: {
            backgroundColor: Colors.dryYellow,
            borderColor: Colors.dryYellow,
            textColor: '#2a3034',
            hover: {
                borderColor: Colors.uiYellowHover,
            },
        },
        disabled: {
            backgroundColor: Colors.galBlack21,
            borderColor: '#3f4548',
            color: Colors.geoWhite21,

            hover: {
                borderColor: '#3f4548',
            },
        },
        educational: {
            backgroundColor: Colors.galBlack100,
            backgroundColorHover: 'rgba(31, 31, 31, 1)',
            color: Colors.geoWhite100,
            unitColor: Colors.geoWhite100,
            projectEdit: {
                backgroundColor: Colors.galBlack100,
                backgroundHover: 'rgba(31, 31, 31, 1)',
                color: '#fefefe',
            }
        },
        modal: {
            search: {
                color: Colors.galBlack47,
                border: Colors.galBlack21,
                borderEmpty: 'transparent',
                bg: Colors.galBlack5
            },
            text: {
                color: Colors.galBlack47,
            },
            header: {
                color: Colors.galBlack100,
                colorLvlOne: Colors.galBlack100
            },
            searchResult: {
                bg: '#f2f2f2'
            },
            active: {
                activeTag: Colors.galBlack100,
                border: Colors.galBlack61
            },
            notActive: {
                // tag: Colors.galBlack73,
                tag: Colors.galBlack100,
                border: Colors.galBlack31
            },
            simpleTag: {
                // color: Colors.galBlack100,
                color: Colors.geoWhite100,
                bottomLine: '#E9EAEB'
            }
        }
    },
    hoverModal: {
        bg: {
            color: '#f2f2f2'
        }
    },
    exploreView: {
        titleColor: Colors.galBlack100,
        mapGridToggle: {
            color: '#8e9193',
            colorHover: '#151514',
        },
        illustrationColor: '#212529'
    },
    allTagsBtn: {
        color: '#8E9193',
        colorHover: '#151514',
        colorBooksBtn: "#909090",
        colorHoverBooksBtn: "#545453"
    },
    multipleAuthors: {
        color: '#8e9193',
        colorHover: '#151514',
        bg: Colors.galBlack5,
        bgHover: Colors.galBlack10,
        arrow: '#151514',
        border: '1px solid #151514',
        shadow: '0px 4px 4px rgba(0, 0, 0, 0.12)'
    },
    designerRole: Colors.galBlack61,
    designerRoleUniversity: Colors.galBlack100,
    textBoldMagic: '#8e9193',
    teamLink: '#8e9193',
    teamLinkHover: Colors.galBlack73,
    teamLinkHoverAccent: Colors.geoWhite61,
    projectToolsDropdown: {
        border: '1px solid #151514',
        borderColor: '#151514',
    },
    projectTools: {
        printButton: Colors.galBlack100,
        outer: Colors.galBlack5,
        rowTitle: Colors.galBlack61,
        rowHover: "#EEE",
        okBtn: "#1F1F1F",
        okBtnText: "#FFF",
    },
    checkbox: {
        border: Colors.galBlack47,
        bg: Colors.gal,
        icon: Colors.galBlack100,
    },
    paginationBtn: {
        color: '#151514',
        border: '1px solid #151514',
    },
    sortByColor: '#8e9193',
    sortByColorSort: '#151514',
    sortByBorder: 'none',
    sortByBg: '',
    sortBySpan: '#151514',
    nameViewHover: '#151514',
    nameView: '#8e9193',
    reportForm: {
        backgroundColor: '#fefefe',
        text: '#151514',
        scroll: '#909090',
        btns: {
            submit: {
                bg: '#151514',
                disabledBg: '#B6B6B5',
                disabledColor: '#FEFEFE',
                color: '#FEFEFE',
                border: '',
                hoverBg: '#efd649',
                weight: '',
            },
            cancel: {
                bg: '',
                color: '#151514',
                border: '1px solid #151514',
                hoverBorder: '1px solid #b1b1b1',
            }
        },
        inputs: {
            dropdown: {
                backgroundColor: Colors.galBlack5,
                backgroundColorHover: Colors.galBlack10,
                scroll: Colors.galBlack47,
            },
            optionsBox: {
                shadowColor: 'linear-gradient(180deg, rgba(50, 55, 59, 0.09) 0%, #32373b 100%)',
                borderColor: Colors.galBlack100,
            },
            backgroundColor: Colors.galBlack5,
            borderColor: Colors.galBlack5,
            color: '#151514',
        }
    },
    feedbackForm: {
        backgroundColor: '#fefefe',
        text: '#151514',
        btns: {
            submit: {
                bg: '#151514',
                color: '#F1DB63',
                border: '1px solid #151514',
                hoverBg: '#424242',
                weight: '700',
            },
            cancel: {
                bg: '',
                color: '#151514',
                border: '1px solid #151514',
                hoverBorder: '1px solid #b1b1b1',
            }
        },
        inputs: {
            dropdown: {
                backgroundColorHover: '',
            },
            optionsBox: {
                shadowColor: 'linear-gradient(180deg, rgba(50, 55, 59, 0.09) 0%, #32373b 100%)',
                borderColor: Colors.galBlack100,
            },
            backgroundColor: '#fefefe',
            borderColor: Colors.galBlack31,
            color: '#151514',
        }
    },
    defaultHolder: {
        bg: '#f2f2f2',
        color: '#70706F'
    },
    projectView: {
        titleColor: '#FEFEFE',
        titleColorMobile: Colors.geoWhite100,
        lGTitleColorMobile: Colors.geoWhite100,
        placeholderColor: '#B6B6B5',
        fontSize: '60px',
        lineHeight: '64px',
        tooltipColor: Colors.galBlack61,
        tooltipColorBG: Colors.galBlack10,
        categoryText: Colors.galBlack47,
        categoryWeight: '700',
        categoryColorHover: '#151514',
        authorText: 'rgba(0,0,0,0.47)',
        authorCuratorText: Colors.galBlack100,
        authorTextMobile: Colors.geoWhite100,
        authorWeight: '400',
        authorColor: Colors.galBlack47,
        authorColorHover: Colors.galBlack100,
        authorArrowIconColor: Colors.galBlack47,
        authorColorHoverMobile: Colors.geoWhite61,
        authorTextSize: '30px',
        textAreaColor: '#151514',
        viewCardText: Colors.galBlack73,
        viewCardStroke: '#909090',
        marginTop: '0px',
        marginBottom: '31px',
        moreProjects: '#151514',
        offsetTop: '0',
        madeBy: Colors.galBlack47,
        border: Colors.defaultGrey5,
        competitionMsg: Colors.galBlack100,
        
    },
    icon: {
        // default: Colors.galBlack47,
        default: 'rgba(0,0,0,0.47)',
        hover: Colors.galBlack100,
        active: Colors.galBlack100,
        hoverSpecial: Colors.galBlack100,
        hoverSpecialActive: Colors.galBlack73,
        activeSpecial: Colors.galBlack100,
        activeFillIconColor: Colors.galBlack100,
        rejectedColor: '#F2F2F2',
    },
    skeleton: {
        skeletonBgColor: '#F2F2F2',
        background: `linear-gradient(
            90deg,
            rgba(0, 0, 0, 0.05),
            rgba(0, 0, 0, 0.05),
            rgba(0, 0, 0, 0.05),
            rgba(0, 0, 0, 0.10),
            rgba(0, 0, 0, 0.05),
            rgba(0, 0, 0, 0.05),
            rgba(0, 0, 0, 0.05)
        )`,
    },

    footerView: {
        backgroundColor: '#F2F2F2',
        textColor: '#6C7073',
        textHoverColor: Colors.dryYellow,
        link: Colors.galBlack47,
        linkHover: Colors.galBlack100,
        linkArrow: Colors.galBlack21,
    },
    arrowWithText: {
        hover: {
            text: {
                color: Colors.galBlack100
            },
            svg: {
                fill: Colors.galBlack100,
                stroke: Colors.galBlack100
            }
        }
    },
    teamsPage: {
        button: {
            bg: '#151514'
        },
        dropdown: {
            text: {
                color: '#212529'
            }
        },
        input: {
            bg: "#F2F2F2",
            color: '#212529'
        },
        text: {
            point: {
                color: '#212529'
            },
            label: {
                color: '#212529'
            },
            icon: {
                fill: '#212529'
            },
            color: '#212529'
        },
    },
    fixedFooter: {
        background: {
            color: "#F2F2F2"
        },
        logo: {
            color: "#151514",
        },
        menuItems: {
            color: '#909090',
            colorDropdown: 'rgba(112, 112, 111, 1)',
            colorHover: "#151514",
            selected: Colors.galBlack100,
        },
        doc: {
            color: '#909090',
            colorHover: "#151514",
        },
        icons: {
            circle: '#F2F2F2',
            arrow: '#909090'
        },
        dropdown: {
            color: '#909090',
            fill: '#909090'
        }
    },

    // Выбор контекста - @Яков
    selectContextModal: {
        background: Colors.gal,
        loaderText: '#70706F',
        opacityTop:
            'linear-gradient(to top, rgba(254, 254, 254, 0), rgba(254, 254, 254, 0.6) 12.39%, rgba(254, 254, 254, 1))',
        opacityBottom:
            'linear-gradient(to bottom, rgba(254, 254, 254, 0), rgba(254, 254, 254, 0.6) 12.39%, rgba(254, 254, 254, 1))',
        variantTextColor: Colors.galBlack100,
    },
    ageModal: {
        bg: '#fff',
        input:{
            color: '#151514'
        },
    },
    sendProjectsModal: {
        title: Colors.galBlack100,
        label: Colors.galBlack47,
        countText: '#909090',
        buttons: {
            send: {
                bg: Colors.galBlack100,
                color: Colors.geoWhite100,
                colorGreen: Colors.galBlack100,
                importantColor: Colors.geoWhite100,
                hoverBg: 'rgb(31, 31, 31)',
                greenBg: 'rgb(164, 181, 77)',
                greenBgHover: 'rgb(164, 181, 77)',
                disable: "#E7E7E7",
                disableClr: '#B6B6B5'
            }
        },
        input: {
            color: '#151514',
            bg: '#f2f2f2'
        }
    },
    competitionLegalsModal: {
        input: {
            bg: Colors.geoWhite100,
            placeholder: '#909090',
            color: Colors.galBlack100,
            border: Colors.galBlack100,
            icon: Colors.galBlack100,
            defaultBorder: Colors.galBlack100
        }
    },
    teamConstructor: {
        bg: Colors.geoWhite100,
        description: {
            bg: Colors.galBlack100,
            color: Colors.geoWhite100,
        },
        smallText: {
            color: Colors.galBlack100,
        },
        fields: {
            bg: Colors.galBlack5,
        }
    },
    shopIcon: '#151514',
    shareIcon: '#151514',
    navigationBar: {
        borderBottomColor: ' #C5C6C7',
        textActiveColor: '#151514',
        closeButtonColor: '#000000',
        backgroundColor: Colors.gal,
        mainNavbarColor: 'rgb(42,48,52)',
        backgroundScrollingColor: 'rgba(254, 254, 254, 0.71)',
        backgroundDirtyColor: '#FF0000',
        font: {
            l: {
                fontSize: '17px',
                lineHeight: '22px'
            },
            m: {
                fontSize: '15px',
                lineHeight: '20px'
            },
            s: {
                fontSize: '13px',
                lineHeight: '16px'
            }
        },
        links: {
            color: Colors.geoWhite47,
            hoverColor: Colors.galBlack100,
            activeColor: Colors.galBlack100,
            disabledColor: 'rgba(142, 145, 147, 0.3)',
            disabledHoverColor: 'rgba(21, 21, 20, 0.3)'
        },
        linksHse: {
            color: Colors.galBlack47,
            hoverColor: Colors.galBlack100,
            activeColor: Colors.galBlack100,
            disabledColor: 'rgba(142, 145, 147, 0.3)',
            disabledHoverColor: 'rgba(21, 21, 20, 0.3)'
        },
        logoName: Colors.galBlack100,
        logoPrefixName: '#FF0000',
        login: {
            loginButtonColor: Colors.geoWhite47,
            loginButtonHoverColor: '#151514',
            noAvatarBackgroundColor: '#30363A',
            noAvatarTextColor: '#707477',
        },
        search: {
            color: '#151514',
            line: '#151514',
            svg: Colors.geoWhite47,
            svgHover: Colors.galBlack100,
            colorFlex: '#151514',
        },
        btns: {
            purchase: {
                background: {
                    color: Colors.galBlack100
                },
                text: {
                    color: Colors.geoWhite100
                }
            },
            filled: {
                importantStyles: {
                    main: Colors.geoWhite100,
                    disabled: Colors.galBlack10,
                    hover: Colors.geoWhite100,
                    active: Colors.galBlack10,
                    text: Colors.galBlack100
                },
                background: {
                    main: Colors.galBlack100,
                    disabled: Colors.galBlack10,
                    active: 'rgba(21, 21, 20, 1)',
                    hover: 'rgba(31, 31, 31, 1)',
                },
                text: {
                    main: '#FFFFFF',
                    disabled: Colors.galBlack31,
                },
            },
            hollow: {
                background: {
                    disabled: Colors.galBlack10,
                },
                text: {
                    main: Colors.galBlack100,
                    grey: Colors.geoWhite31,
                    black: Colors.galBlack100,
                    disabled: Colors.galBlack31,
                },
                border: {
                    main: Colors.galBlack31,
                    hover: Colors.galBlack47,
                    active: Colors.galBlack100,
                    disabled: Colors.galBlack31,
                },
            },
            send: {
                color: 'transparent',
                textColor: '#151514',
                border: '',
            },
            create: {
                bg: '#151514',
                color: '#FFFFFF',
                weight: 'bold',
                border: '1px solid transparent',
            },
            changeLang: {
                background: Colors.geoWhite100,
                color: Colors.galBlack47,
                colorMobile: Colors.galBlack100,
                colorHover: Colors.galBlack47,
                active: Colors.galBlack100,
            },
            showMore: {
                hover: {
                    color: '#151514'
                }
            }
        },
        modalMobileLinks: {
            default: Colors.galBlack47,
            active: Colors.galBlack100,
        },
        linksWidgetLine: '#151514',
        linksWidgetLineGradient: Colors.galBlack100, //old 'radial-gradient(100% 1562500% at 0% 100.02%,rgba(255, 255, 255, 0) 0%,#151514 49.87%,rgba(254, 254, 254, 0) 100%)',
        navBarCreate: {
            boldTextColor: Colors.galBlack73,
            textColor: Colors.galBlack73,
            logoFillColor: {
                first: '#151514',
                second: '#151514',
            },
        },
        dropdownStyled: {
            borderFocused: '#151514',
            bg: '#fefefe',
            border: '1px solid #B6B6B5',
            textColor: '#151514',
            opacity: '0.7',
            fill: '#151514',
        },
        profile: {
            textColor: '#151514',
            textSmallColor: '#8e9193',
            bg: '#fefefe',
        },
        mobileMenu: {
            item: {
                color: '#151514',
                bg: '#F2F2F2'
            },
            container: {
                bg: '#F2F2F2'
            },
            search: {
                bg: '#fefefe'
                // bg: '#f2f2f2'
            },
            tab: {
                color: '#909090',
                colorActive: '#151514'
            }
        }
    },
    mobileSearch: {
        wrapper: {
            background: Colors.galBlack5,
            backgroundHover: Colors.galBlack10,
        },
        scroll: {
            body: '#909090',
            background: Colors.galBlack10,
        },
        input: {
            color: Colors.galBlack100
        },
        item: {
            color: Colors.galBlack100,
        }
    },
    likesController: {
        textColor: Colors.galBlack47,
        fill: '',
        hearthColor: Colors.galBlack47,
        hearthColorLikes: Colors.redFailed,
        text: Colors.galBlack47,
    },
    viewCount: {
        text: Colors.galBlack47
    },
    likesPopUp: {
        bg: '#fefefe',
        color: '#8e9391',
        hoverColor: '#151514',
        bgHover: '#f2f2f2',
        borderBox: '1px solid black',
    },
    likesPopUpNew: {
        bg: Colors.galBlack5,
        color: Colors.galBlack100,
        bgHover: Colors.galBlack10,
        scrollBody: Colors.galBlack47,
    },
    researchPage: {
        colorMainTitle: '#151514',
    },
    btns: {
        submit: {
            bg: '#151514',
            color: '#F1DB63',
            border: '1px solid #151514',
            hoverBg: '#424242',
            weight: '700',
        },
        cancel: {
            bg: '',
            color: '#151514',
            border: '1px solid #151514',
            hoverBorder: '1px solid #b1b1b1',
        },
        hollow: {
            border: Colors.galBlack31,
            borderActive: Colors.galBlack100,
            icon: Colors.galBlack100,
        },
    },
    inputs: {
        dropdown: {
            backgroundColorHover: '',
        },
        optionsBox: {
            shadowColor: 'linear-gradient(180deg, rgba(50, 55, 59, 0.09) 0%, #32373b 100%)',
            borderColor: Colors.galBlack100,
        },
        backgroundColor: Colors.geoWhite100,
        borderColor: Colors.galBlack31,
        borderFocusedColor: Colors.galBlack100,
        color: '#151514',
        disabledColor: Colors.galBlack47,
        pagination: {
            backgroundColor: Colors.galBlack10,
            color: Colors.galBlack100,
            mainPagination: {
                pageBg: {
                    bg: '#E7E7E7'
                }
            }
        },
        box: {
            backgroundColor: Colors.galBlack5
        },
        label: {
            color: Colors.galBlack73
        },
        text: {
            color: Colors.galBlack47
        }
    },
    dropdown: {
        textColor: '#151514',
        bgColor: '#fefefe',
        bgColorHover: '#f2f2f2',
        borderColor: '#B6B6B5',
        borderFocusColor: '#151514',
        arrow: '#151514',
        shadow: 'rgba(0,0,0,0)',
        shadowEnd: 'rgba(254,254,254,1)',

        shadowHse: 'rgba(0,0,0,0)',
        shadowHseEnd: '#343434',
        webkitShadowStart: 'rgba(52,52,52,1)',
        webkitShadowEnd: 'rgba(52,52,52,0.3)'
    },
    spinner: {
        loaderColor: '#F2F2F2',
        loaderBg: '#fefefe',
    },
    designerPage: {
        emptyProjectsLoader: {
            color: '#151514',
            bg: '#F2F2F2',
        },
        noProjectBlock: {
            infoBlock: {
                bg: '#f2f2f2',
                color: '#151514'
            },
            avatar: {
                color: '#70706f',
                bg: '#CDCDCD',
                size: {
                    l: 48,
                }
            }
        },
        likePowerIcon: {
            color: Colors.galBlack47,
            bg: 'rgba(21,21,20,0.73)',
            opacity: '0.73',
            msgColor: Colors.geoWhite100,
            shrinkColor: Colors.geoWhite100,
            hover: Colors.galBlack73
        },
        slideShadow: 'linear-gradient(270deg, #FFF 9.68%, rgba(255, 255, 255, 0.00) 100%)',
        slideItemBg: Colors.defaultGrey6,
        textColor: '#151514',
        textColor2: Colors.galBlack47,
        textColor3: Colors.galBlack100,
        sliderDropdownColor: Colors.galBlack100,
        fill: '#151514',
        moreDropdown: '1px solid #151514',
        slideLine: '#151514',
        slideNavActiveTabUnderline: '#151514',
        slideLineInActive: Colors.galBlack47,
        slideHover: Colors.galBlack73,
        blueSelectBG: '#609AF0',
        blueSelectColor: '#fefefe'    
    },
    wideCover: {
        info: {
            author: {
                color: Colors.galBlack47,
            },
            title: {
                color: '#151514'
            }

        }
    },
    teamsEdit: {
        inputs: {
            labelColor: Colors.galBlack47,
            importantColor: Colors.galBlack47,
            whiteLabelColor: Colors.galBlack47,
            bgDisabled: '#f2f2f2',
            bg: '#ffffff',
            border: '1px soled #8E9193',
            color: '#151514',
            colorShadow: '#BFBFBF'
        }
    },
    designerEdit: {
        btns: {
            edit: {
                bg: '#151514',
                color: Colors.geoWhite100,
                border: '1px solid #151514',
                hoverBg: '#424242',
                weight: '700',
            },
            cancel: {
                bg: '',
                color: '#151514',
                border: '1px solid #151514',
                hoverBorder: '1px solid #b1b1b1',
            },
            roundAdd: {
                svgColor: 'black',
                textColor: Colors.galBlack47,
            },
        },
        localSwitch: {
            borderColor: '#151514',
            textColor: '#151514',
            textColorInactive: Colors.galBlack47,
            textColorHover: '#151514',
        },
        inputs: {
            labelColor: Colors.galBlack47,
            importantColor: Colors.galBlack47,
            whiteLabelColor: Colors.galBlack47,
            bgDisabled: '#f2f2f2',
            bg: '#ffffff',
            border: '1px soled #8E9193',
            color: '#151514',
            colorShadow: '#BFBFBF'
        },
        smallText: {
            color73: '#8E9193',
            color100: '#8E9193',
            color47: Colors.galBlack47,
            colorB6: '#B6B6B5',
            colorE7: '#8E9193'
        },
        editTitle: {
            color: Colors.galBlack61,
            secondColor: Colors.galBlack100
        },
        mainTitle: {
            color: Colors.galBlack100,
        },
        pageLink: {
            color: Colors.galBlack47,
            hoverColor: '#151514',
        },
        aboutProfile: {
            bg: Colors.galBlack5,
            bgWhite: '',
            color: '#545453',
        },
        mergeAccount: {
            bg: Colors.geoWhite100
        },
        account: {
            color: Colors.galBlack73,
            color47: Colors.galBlack47,
            goButtonColor: Colors.galBlack73,
            color31: Colors.geoWhite10,
            fill: Colors.galBlack21
        },
        icons: {
            color: Colors.galBlack47,
            colorHover: Colors.galBlack100
        },
        disable: {
            color: Colors.galBlack27,
            colorGeo: ''
        },
        placeholder: {
            color: Colors.galBlack47,
        }
    },
    map: {
        closeBtn: '#151514',
        bg: '#fefefe',
        teams: {
            text: Colors.galBlack61,
            secondaryText: Colors.galBlack47,
            scroll: '#CDCDCD'
        }
    },
    footer: {
        border: 'transparent',
    },
    errorModal: {
        textColor: Colors.galBlack100,
        textColorSecond: Colors.galBlack73,
        secondaryTextColor: Colors.galBlack47,
        backgroundColor: Colors.gal,
    },

    modal: {
        closeColor: Colors.galBlack100,
        backgroundColor: 'rgba(255, 255, 255)',
        solidBackgroundColor: Colors.gal,
        overflowColor: 'rgba(21, 21, 20, 0.6)',
    },
    not_saved_modal: {
        title: Colors.galBlack100,
        description: Colors.galBlack61,
        cancel: Colors.geoWhite100,
        proceed: Colors.galBlack100,
        channelTitle: Colors.galBlack100
    },
    menuOverlay: {
        buttonBackground: '#fefefe',
        buttonContent: 'rgb(142, 145, 147)',
        buttonOpacity: 1,
        backgroundColor: '#FEFEFE',
        textColor: '#151514',
        textColorAlternative: '#abaeaf',
        borderTitle: '#151514',
        flexBox: 'rgb(254, 254, 254, 0.71)',
    },
    approvals: {

    },
    isDarkText: true,
    link: {
        default: Colors.galBlack47,
        hover: Colors.galBlack100,
    },
    linkSpecial: {
        hover: Colors.galBlack100,
    },
    scrollUp: {
        link: '#909090',
        background: 'transparent',
        backgroundHover: hexToRGB('#909090', 0.01)
    },
    text: {
        label: Colors.galBlack47,
    },
    mobileMenu: {
        background: '#FFFFFF',
    },
    notifications: {
        background: Colors.galBlack5,
        backgroundUnread: Colors.galBlack21,
        backgroundHover: "#E7E7E7",
        projectBackground: "#FFFFFF",
        projectBackgroundUnread: Colors.galBlack10,
        likes: Colors.galBlack47,
        textColor: Colors.galBlack100,
        link: Colors.galBlack100,

        name: {
            color: "#151514",
        }
    },
    errorPage: {
        notFound: {
            number: Colors.galBlack21,
            title: Colors.galBlack47
        },
        title: Colors.galBlack73,
        subtitle: Colors.galBlack73,
        text: Colors.galBlack47,
        buttons: {
            border: Colors.galBlack31,
            hollowText: Colors.zel,
            bg: Colors.galBlack100,
            filledText: "#fff",
            disabledBg: Colors.galBlack21,
            disabledColor: Colors.galBlack31,
        }
    },
    imagePlaceholder: {
        bg: Colors.galBlack5,
        icon: Colors.galBlack47
    },
    draftCreate: {
        primary: "#F2F2F2",
        secondary: "#30363a",
        borderHover: "#8e9193",
        textHover: "#8e9193",
        title: Colors.geoWhite61,
        draftCards: {
            psn_card: {
                color: Colors.galBlack100
            }
        }
    },
    tagAdminPage: {
        dropdownSelected: "#151514",
        dropdown: "",
        inputs: {
            bg: '#f2f2f2',
            border: 'rgba(144, 144, 144, 1)',
            placeholder: {
                color: 'rgba(144, 144, 144, 1)'
            }
        },
        checkbox: {
            bg: '#fefefe'
        },
        select: {
            color: '#151514'
        },
        scrollBar: {
            bg: '#909090',
            trackBg: 'rgb(231, 231, 231)'
        },
        icons: {
            fill: '#909090'
        },
        tagExpert: {
            mainText: Colors.galBlack73,
            secondaryText: Colors.galBlack47,
            secondaryTextHover: Colors.galBlack100,
            background: Colors.galBlack5
        },
        switcher: {
            bg: '#F2F2F2',
            item: {
                color: Colors.galBlack47,
                hoverColor: Colors.galBlack100
            }
        }
    },
    madeByMedia: {
        background: '#151514',
        color: '#FEFEFE'
    }
} as ApplicationThemeT;
